<template>
    <div class="steps" :class="[gray && gray.fieldReview && !inYoda ? 'fixed-steps' : '', inYoda && !useTitle ? 'fixed-steps-no-nav' : '']">
        <div class="stages">
            <div class="stage" v-for="(step, idx) in steps" :key="step.title">
                <div class="line" v-if="idx > 0" :class="{ on: idx <= onIdx }"></div>
                <div
                    class="square"
                    @click="onStepsClick({
                        idx: idx,
                        nextPageKey: steps[idx].pageKey,
                        isError: showImportantIcon(step),
                        curIndex: onIdx
                    })"
                >
                    <div v-if="showImportantIcon(step)" class="active"></div>
                    <div class="ball" :class="{ on: idx === onIdx, past: idx < onIdx }">
                        {{ idx + 1 }}
                    </div>
                    <div class="title" :class="{ on: idx <= onIdx }">
                        {{ step.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-line"></div>
    </div>
</template>
<style lang="less" scoped>
@import '../assets/style/all.less';
.fixed-steps {
    position: fixed;
    left: 0;
    top: 0.4rem;
    width: 100%;
    height: 86px;
    z-index: 999;
}
.fixed-steps-no-nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 86px;
    z-index: 999;
}
.steps {
    background: #fff;
    .stages {
        .f();
        padding: 16px 52 / 375 * 100% 49px;
        justify-content: space-between;
    }
    .bottom-line {
        height: 1px;
        background: #eaeaea;
    }
    .stage {
        .f();
        .f-1();
        .f-ai-cen();
        &:first-of-type {
            flex: none;
        }
        .line {
            .f-1();
            height: 1px;
            background: #eaeaea;
            margin: 0 4px;
            &.on {
                background: @brand-color;
            }
        }
        .square {
            .f();
            .f-cen();
            .relative();
            width: 20px;
            height: 20px;
            position: relative;
            .title {
                .absolute();
                .font-14();
                white-space: nowrap;
                left: 50%;
                color: #9c9c9c;
                transform: translateX(-50%);
                height: 17px;
                line-height: 17px;
                bottom: -25px;
                &.on {
                    color: #303030;
                }
            }
        }
        .active {
            position: absolute;
            right: -12px;
            top: -12px;
            width: 16px;
            height: 16px;
            background-image: url(../assets/error.svg);
            background-size: 16px 16px;
        }
        .ball {
            width: 20px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 999rem;
            background: #c6c6c6;
            color: #fff;
            &.on {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 20px;
                height: 20px;
                background: @brand-color;
                border: 2px solid @brand-color;
                border-radius: 100%;
                margin: 0;
                font-size: 14px;
                box-sizing: border-box;
                color: #fff;
            }
            &.past {
                width: 20px;
                height: 20px;
                background: @brand-color;
            }
        }
    }
}
</style>

<script>
import { mapState } from 'vuex';
import { inYoda } from '@/utils/device';

export default {
    name: 'mobile-steps',
    data() {
        return {
            inYoda: inYoda,
        };
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
        rejectPages: {
            type: Array,
            default: () => [],
            required: false,
        },
        hasChangedRejectReview: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapState([
            'gray',
            'status',
            'bizInfo',
            'useTitle',
        ]),
        onIdx() {
            return this.steps.findIndex(step => step.current);
        },
        // 符合信息收集字段级驳回的前置条件
        /**
         * 1. 在灰度中
         * 2. 支持审核
         * 3. 表单状态为 3
         */ 
        accordWithRule() {
            const { fieldReview = 0 } = this.gray;
            const { config = {} } = this.bizInfo;
            const { needProcess } = config;
            return fieldReview && this.status === 3 && needProcess;
        },
    },
    methods: {
        onStepsClick(clickParams) {
            const { idx } = clickParams;
            if (typeof idx === 'undefined') { return; }
            this.$emit('step-click', clickParams);
        },
        // 展示步骤条！icon
        showImportantIcon(step) {
            const { pageKey } = step;
            // 命中灰度 表单状态为3-已驳回 支持审核
            return this.accordWithRule && this.rejectPagesHasCurTitle(pageKey) && !this.hasChangeRejectReviewHasCurPageKey(pageKey);
        },
        // 被驳回的page中存在当前pageKey
        rejectPagesHasCurTitle(pageKey) {
            return this.rejectPages ? this.rejectPages.includes(pageKey) : false;
        },
        // 有变化的page中是否存在当前pageKey
        hasChangeRejectReviewHasCurPageKey(pageKey) {
            return this.hasChangedRejectReview ? this.hasChangedRejectReview.includes(pageKey) : false;
        },
    },
};
</script>
